var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConditionalArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1453_38984",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1453_38984)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2H5C4.45 2 4 2.45 4 3C4 3.55 4.45 4 5 4H19C19.55 4 20 3.55 20 3C20 2.45 19.55 2 19 2ZM13 11.414V21C13 21.55 12.55 22 12 22C11.45 22 11 21.55 11 21V11.414L7.707 14.707C7.615 14.799 7.504 14.872 7.382 14.923C7.138 15.024 6.862 15.024 6.618 14.923C6.373 14.821 6.179 14.627 6.077 14.382C6.028 14.263 6.003 14.136 6.001 14.008C6.001 14.0065 6.00075 14.0053 6.0005 14.004C6.00025 14.0028 6 14.0015 6 14C6 13.9985 6.00025 13.9972 6.0005 13.996C6.00075 13.9947 6.001 13.9935 6.001 13.992C6.003 13.864 6.028 13.737 6.077 13.618C6.128 13.496 6.201 13.385 6.293 13.293L11.293 8.293C11.3235 8.26248 11.3606 8.2412 11.3979 8.21983C11.4169 8.20898 11.4358 8.19811 11.454 8.186C11.471 8.17432 11.4874 8.16184 11.5037 8.14942C11.539 8.12248 11.5739 8.09579 11.615 8.078C11.736 8.027 11.867 8 12 8C12.133 8 12.264 8.027 12.385 8.078C12.425 8.09495 12.4586 8.12062 12.4925 8.14662C12.5087 8.15897 12.5249 8.1714 12.542 8.183C12.5595 8.19444 12.5778 8.20497 12.5961 8.21552C12.6354 8.23818 12.6749 8.26093 12.707 8.293L17.707 13.293C17.799 13.385 17.872 13.496 17.923 13.618C18.024 13.862 18.024 14.138 17.923 14.382C17.821 14.627 17.626 14.821 17.382 14.923C17.138 15.024 16.862 15.024 16.618 14.923C16.496 14.872 16.385 14.799 16.293 14.707L13 11.414Z",
    fill: "#005EB8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionalArrow);
export default __webpack_public_path__ + "static/media/conditional_arrow.4bfb1d62813852ab6c721003b3455826.svg";
export { ForwardRef as ReactComponent };